import HusklyLogo from "./HusklyLogo";

export default function Nav() {
  return (
    <nav className="fixed top-0 inset-x-0 z-50 border-b border-navy-700/60 bg-navy-950/85 backdrop-blur-md">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          {/* Huskly brand */}
          <div className="flex items-center gap-3">
            <HusklyLogo className="h-9 w-12" />
            <div className="flex flex-col leading-none gap-0.5">
              <span className="text-sm font-bold tracking-wide text-gradient">
                Huskly
              </span>
              <span className="text-[10px] text-slate-500 tracking-widest uppercase font-medium">
                Aegis Vol
              </span>
            </div>
          </div>

          {/* Nav links */}
          <div className="hidden md:flex items-center gap-8">
            <a
              href="#features"
              className="text-sm text-slate-400 hover:text-white transition-colors"
            >
              Features
            </a>
            <a
              href="#pipeline"
              className="text-sm text-slate-400 hover:text-white transition-colors"
            >
              How It Works
            </a>
            <a
              href="#philosophy"
              className="text-sm text-slate-400 hover:text-white transition-colors"
            >
              Philosophy
            </a>
            <a
              href="#contact"
              className="text-sm text-slate-400 hover:text-white transition-colors"
            >
              Contact
            </a>
          </div>

          {/* CTA — Huskly neon green */}
          <a
            href="#contact"
            className="rounded-full bg-huskly-green px-5 py-2 text-sm font-bold text-navy-950 hover:bg-huskly-green-light transition-colors"
          >
            Request Access
          </a>
        </div>
      </div>
    </nav>
  );
}
